import { render, staticRenderFns } from "./SelectIdCard.vue?vue&type=template&id=0c5f95fc&"
import script from "./SelectIdCard.vue?vue&type=script&lang=js&"
export * from "./SelectIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports